import {ChemDrawStoichiometryData, ParseReactionComponentsResponse} from 'chemistry/ChemistryConstants';
import {ExternalFile} from 'notebook/util/NoteUtilConstants';
import * as net from 'util/Net';

export const SALT_LIBRARY_URL = '/salts/listing';
export const SOLVATE_LIBRARY_URL = '/solvates/listing';

export function bulkFetchChemDrawStoichiometryData(
  noteLinkedObjectIds: Array<string>
): Promise<{[noteLinkedObjectId: string]: ChemDrawStoichiometryData}> {
  return net.postJSONPromise({
    url: '/1/api/chemistry:bulk-fetch-chemdraw-stoichiometry-data',
    data: {noteLinkedObjectIds},
  });
}

export function parseReactionComponents(
  mrvFile: string,
  folderId: string | undefined
): Promise<ParseReactionComponentsResponse> {
  return net.postJSONPromise({
    url: '/1/api/reactions:process-components',
    data: {mrvFile, folderId},
  });
}

export function generateReactionImage(mrvFile: string): Promise<{base64SVG: string}> {
  return net.postJSONPromise({
    url: '/1/api/reactions:generate-image',
    data: {mrvFile},
  });
}

export interface BuildReactionFromComponentsResponse {
  externalFile: ExternalFile;
}

export function buildReactionFromComponents(
  reactantMoleculeIds: Array<string>,
  productMoleculeIds: Array<string>
): Promise<BuildReactionFromComponentsResponse> {
  return net.postJSONPromise({
    url: '/1/api/reactions:build-from-components',
    data: {reactantMoleculeIds, productMoleculeIds},
  });
}
